import React from "react";

const images = [
  "/img/carousel/carousel-1.webp",
  "/img/carousel/carousel-2.webp",
  "/img/carousel/carousel-3.webp",
  "/img/carousel/carousel-4.webp",
  "/img/carousel/carousel-5.webp",
  "/img/carousel/carousel-6.webp",
  "/img/carousel/carousel-7.webp",
  "/img/carousel/carousel-8.webp",
  "/img/carousel/carousel-9.webp",
  "/img/carousel/carousel-10.webp",
  "/img/carousel/carousel-11.webp",
  "/img/carousel/carousel-12.webp",
];

// Preload images
if (typeof window !== 'undefined') {
  images.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}

export default function Carousel3D() {
  const count = 12;
  const step = 360 / count;

  // тойргийн хэмжээ - утсан дээр бага
  const radius = window.innerWidth <= 768 ? 150 : 520;

  // налуу
  const tiltX = -35;

  return (
    <div className="stage">
      <div className="viewport">
        {/* tiltX-ийг CSS variable-р өгч байна */}
        <div className="ring auto" style={{ "--tiltX": `${tiltX}deg` }}>
          {images.map((it, i) => (
            <div
              key={`carousel-${i}`}
              className="card"
              style={{
                transform: `rotateY(${i * step}deg) translateZ(${radius}px)`,
              }}
            >
              <div className="cardInner">
                <img 
                  className="face front" 
                  src={it} 
                  alt="" 
                  draggable={false}
                  loading="eager"
                  decoding="async"
                  fetchpriority="high"
                />
                <img 
                  className="face back" 
                  src={it} 
                  alt="" 
                  draggable={false}
                  loading="eager"
                  decoding="async"
                  fetchpriority="high"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
